import LabelledElement from "./LabelledElement";
import { TextField, Typography } from "@mui/material";

const TextElement = ({ label, value, onChange, multiline }) => {
  const isEditable = typeof onChange === "function";

  return (
    <LabelledElement label={label}>
      {isEditable ? (
        <TextField
          value={value}
          onChange={onChange}
          size={"small"}
          multiline={multiline}
          minRows={multiline ? 3 : null}
        />
      ) : (
        <Typography>{value}</Typography>
      )}
    </LabelledElement>
  );
};

export default TextElement;
